import * as React from 'react';
import {
  DateTimeFormat,
  DateTimeFormats,
  DateTimeFormatterFn,
  useDateTimeFormat,
  useDateTimeFormatter
} from '../../hooks';
import { DateTypes } from '../../hooks/useDateTimeFormat';

export interface DatePeriodFormatterProps {
  startDate?: DateTypes;
  endDate?: DateTypes;
  id?: string;
}

export const DatePeriodFormatter: React.FC<React.PropsWithChildren<DatePeriodFormatterProps>> = ({
  startDate,
  endDate,
  id
}) => {
  const { dateTimeFormatter } = useDateTimeFormatter();
  const { dateTimeFormat } = useDateTimeFormat();
  if (!startDate && !endDate) return null;

  return (
    <span className="date-period" id={id}>
      {formatPeriod(startDate, endDate, dateTimeFormatter, dateTimeFormat)}
    </span>
  );
};

function formatPeriod(
  startDate: DateTypes | undefined,
  endDate: DateTypes | undefined,
  dateTimeFormatter: DateTimeFormatterFn,
  dateTimeFormat: DateTimeFormat
) {
  let isSameYear = false;
  if (startDate && endDate && new Date(startDate).getFullYear() === new Date(endDate).getFullYear()) {
    isSameYear = true;
  }
  const isYearMonthDay = dateTimeFormat.threeLetterDateFormat === 'ymd';
  // For dmy and mdy display period as 1 Sep - 31 Oct 2022 and Sep 1 - Oct 31 2022 respectively.
  // For ymy display period as 2022 Sep 1 - Oct 31 keeping year first for readability.
  const start = dateTimeFormatter(startDate, {
    long: true,
    format: isSameYear && !isYearMonthDay ? DateTimeFormats.LONG_DAY_MONTH : undefined
  });
  const end = dateTimeFormatter(endDate, {
    long: true,
    format: isSameYear && isYearMonthDay ? DateTimeFormats.LONG_DAY_MONTH : undefined
  });

  return start === '-' && end === '-' ? '' : `${start ?? ''} - ${end ?? ''}`.trim();
}
